import { all, put, takeLatest } from 'redux-saga/effects'

import {
    NotificationCenterAction,
    NotificationCenterActionCategory,
    NotificationCenterCategory,
} from '../../@paco/entities/NotificationCenter/NotificationCenter'
import {
    endEventLoggerApiCall,
    startEventLoggerApiCall,
} from '../../@paco/entities/NotificationCenter/NotificationCenterService'
import { transformAndSetSettings } from '../../@paco/redux/settings/settingsActions'

import { TOAST_TYPE_PASS } from '../../constants'
import { getObjProperty } from '../../helpers'
import { delSettings, getSettings, putSettings } from '../../helpers/api-ts/settingsApi'
import { translate } from '../../helpers/translations/translator'
import {
    APP_SAGA_ADD_TOAST,
    SETTINGS_GET_SETTINGS_FAILURE,
    SETTINGS_GET_SETTINGS_REQUEST,
    SETTINGS_GET_SETTINGS_SUCCESS,
    SETTINGS_SAGA_GET_SETTINGS,
    SETTINGS_SAGA_SET_SETTINGS,
    SETTINGS_SET_SETTINGS_FAILURE,
    SETTINGS_SET_SETTINGS_REQUEST,
    SETTINGS_SET_SETTINGS_SUCCESS,
} from '../actionTypes'

export function* fetchSettings() {
    yield put({ type: SETTINGS_GET_SETTINGS_REQUEST })

    try {
        const response = yield getSettings()

        // Trigger a Redux Thunk action inside a saga
        yield put(transformAndSetSettings(response.data))

        const settings = response.data.map(setting => ({
            ...setting,
            departmentId: getObjProperty(setting, 'department.id') || undefined,
        }))
        yield put({ type: SETTINGS_GET_SETTINGS_SUCCESS, settings })
    } catch (error) {
        yield put({ type: SETTINGS_GET_SETTINGS_FAILURE })
    }
}

function* setSettings(action) {
    yield put({ type: SETTINGS_SET_SETTINGS_REQUEST })

    try {
        const putData = action.settings.filter(setting => ! setting.delete)
        const deleteData = action.settings.filter(setting => ! setting.new && setting.delete)

        if (putData.length) {
            const responseTracker = yield startEventLoggerApiCall(
                NotificationCenterCategory.SETTING,
                NotificationCenterAction.UPDATED,
                [NotificationCenterActionCategory.UNKNOWN],
            )

            yield putSettings(putData, responseTracker.data)

            yield endEventLoggerApiCall(responseTracker.data)
        }
        if (deleteData.length) {
            const responseTracker = yield startEventLoggerApiCall(
                NotificationCenterCategory.SETTING,
                NotificationCenterAction.DELETED,
                [NotificationCenterActionCategory.UNKNOWN],
            )

            yield delSettings(deleteData, responseTracker.data)

            yield endEventLoggerApiCall(responseTracker.data)
        }

        yield all([
            yield fetchSettings(),
        ])

        yield put({ type: APP_SAGA_ADD_TOAST, toast: translate('pages.settings.updateSettingsSuccess'), toastType: TOAST_TYPE_PASS })
        yield put({ type: SETTINGS_SET_SETTINGS_SUCCESS })
    } catch (error) {
        yield put({ type: SETTINGS_SET_SETTINGS_FAILURE })
    }
}

export default function* settingsWatcher() {
    yield takeLatest(SETTINGS_SAGA_GET_SETTINGS, fetchSettings)
    yield takeLatest(SETTINGS_SAGA_SET_SETTINGS, setSettings)
}
